<template>
	<div class="box-collection">
		<div class="area_title">
			<div class="text">favoritos</div>
			<div class="select-status">
				<span class="txt-status">Tipo de objeto:</span>
				<div class="select">
					<select name="status" placeholder="Todas" v-model="tipo" @change="aplicarFiltro()">
						<option value="">Todas</option>
						<option :value="tipo.id" v-for="tipo in tiposList" :key="tipo.id">{{ tipo.nome }}</option>
					</select>
					<i class="fas fa-chevron-down" ></i>
				</div>
			</div>
		</div>
		<hr>
		<div class="top_actions">
			<div class="txt-total-itens">Você possui {{ totalItens }} favoritos </div>
		</div>
		<div v-if="!isLoad">
			<div class= "collection" v-for="lc in filteredCollections" :key="lc.id">
				<router-link :to="{ name: 'objeto', params: { id: lc.id }}">
					<div class="icon">
						<span class="far fa-file-alt"></span>
					</div>
				</router-link>
				<router-link :to="{ name: 'objeto', params: { id: lc.id }}">
					<div class="collection_name">
						{{ lc.tituloObjeto }}
					</div>
				</router-link>
				<div class="number">
					<div class=""> Tipo: <span class="box-number">{{ lc.tipoNome }}</span> </div>
				</div>
				<div class="actions">
					<div class="view" @click="visualizar(lc.id)"><i class="fas fa-eye"></i><span class="txt">visualizar</span></div>
					<div class="delete" @click="remove(lc.id)"><i class="fas fa-trash-alt"></i><span class="txt">excluir</span></div>
				</div>
			</div>
		</div>
		<hr v-if="!isLoad">
		<Pagination :totalItens="totalItens" v-if="totalItens > 20" :currentPage="currentPage" @pagina="getFilteredCollections" :pagesQuantity="take"/>
		<ModalRemove @boxDescartar="descartar" @boxDelete="removeCollection" :id="objeto" :boxRemove="boxRemove" v-if="boxRemove" titulo="Deseja desfavoritar esse objeto ?" subTitulo="Não é possível restaurar essa ação."/>
		<Load v-if="isLoad"></Load>
	</div>
</template>

<script>
import Load from '@/components/shared/Load'
import Pagination from '@/components/shared/Pagination'
import ModalRemove from '@/components/shared/ModalRemove'
import { usuarios } from '@/services/usuarios'
import { tipos } from '@/services/tipos'
import EventBus from './../../event-bus'

export default {
	name: 'MeusFavoritos',
	components: { ModalRemove, Pagination, Load },
	data () {
		return {
			ordem: 'asc',
			take: 20,
			filteredCollections: [],
			boxRemove: false,
			userId: '',
			totalItens: 0,
			currentPage: 1,
			skip: 0,
			status: '',
			tiposList: [],
			tipo: '',
			objeto: '',
			isLoad: false
		}
	},
	async created () {
		this.userId = this.$auth.user().id
		await tipos.find()
			.then(res => {
				this.tiposList = res.data
			})
			.catch(err => console.log(err))
		this.getFilteredCollections()
	},
	watch: {
		'$route.query': function () {
			this.getFilteredCollections()
		}
	},
	methods: {
		async getFilteredCollections () {
			this.isLoad = true
			this.totalItens = 0
			this.skip = parseInt(this.$route.query.skip) - 1 || this.currentPage - 1
			this.currentPage = parseInt(this.$route.query.skip) || this.currentPage
			this.filteredCollections = []
			await usuarios.objetosFavoritos(this.userId, this.$route.query.skip ? this.$route.query.skip - 1 : 0, this.take, this.tipo)
				.then(res => {
					this.totalItens = res.data.length > 0 ? res.data[0].totalDeFavoritos : res.data.length
					this.filteredCollections = res.data
				})
				.catch(err => console.log(err))
			EventBus.$emit('closeLoader', false)
			this.isLoad = false
		},
		visualizar (id) {
			this.$router.push(`/objeto/${id}`)
		},
		remove (objeto) {
			this.boxRemove = !this.boxRemove
			this.objeto = objeto
		},
		async removeCollection () {
			await usuarios.desvincularFavoritos(this.userId, this.objeto)
			this.filteredCollections = []
			this.descartar()
			this.getFilteredCollections(this.currentPage)
		},
		descartar () {
			this.boxRemove = !this.boxRemove
		},
		aplicarFiltro () {
			return this.$router.push({
				name: 'meusFavoritos',
				query: { skip: 1, tipo: this.tipo }
			})
		}
	}
}
</script>

<style lang="scss" scoped>

	.box-collection {
		margin-top: 40px;

		.area_title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-family: "Roboto Condensed","Roboto",sans-serif;
			font-size: 22px;
			font-weight: bold;
			color: #fff;
			text-transform: uppercase;

			.text {
				color: #fff;
				text-transform: uppercase;
				margin-right: 20px;
			}
			.select-status {
				display: flex;
				align-items: center;

				.txt-status {
					font-size: 14px;
					margin-right: 20px;
				}
				.select {
					font-size: 16px;

					select {
						width:207px;
						padding: 1px 20px;
						font-size: 16px;
						line-height: 31px;
						color: #8B94A7;
						background-color: #061529;
						margin: 0;
						border: 0;
						border-radius: 5px;
						appearance: none;
					}

					i {
						color: #8B94A7;
						margin-left: 10px;
						position: relative;
						left: -25px;
					}
				}
			}
		}
		hr {
			border: 1px solid #D1D1D1;
			width: 100%;
			opacity: 0.15;
		}
		.top_actions {
			display: flex;
			justify-content: flex-end;

			.txt-total-itens {
				margin-top: 20px;
				margin-bottom: 10px;
			}
		}
		.collection {
				display: grid;
				align-items: center;
				align-content: center;
				grid-template-columns: .5fr 5fr 3fr 1fr;
				padding: 10px 30px;
				border: 2px solid #21344D;
				border-radius: 10px;
				background-color: #061529;
				color: #59708F;
				font-family: 'Roboto Condensed', 'Roboto', sans-serif;
				margin-bottom: 20px;

				a:hover, a:link, a:visited, a:active {
					text-decoration: none;
				}
				a:hover {
					opacity: 0.8;
				}

				body.light & {
					color: #FFF;
				}

				.icon {
					color: #59708F;
					font-size: 30px;
				}
				.collection_name {
					font: Condensed 20px Roboto;
					color: #FFF;
					text-transform: uppercase;
				}

				.number {
					display: flex;
					align-items: center;
					font-family: Roboto;
					font-stretch: condensed;
					font-size: 20px;

					.enviado, .finalizado {
						display:flex;
						align-items: center;

						.box-number {
							display: flex;
							justify-content: center;
							background-color: #59708F;
							padding: 5px 10px;
							border-radius: 100px;
							color:#061529;
							min-width: 100px;
							margin-left: 5px;
						}

						.box-number-final {
							display: flex;
							justify-content: center;
							background-color: #061529;
							padding: 5px 10px;
							border-radius: 100px;
							color:#59708F;
							min-width: 100px;
							margin-left: 5px;
							border: 1px solid #59708F;
						}
					}
				}

				.icon-status {
					font-size: 20px;
					& .hourglass {
						color: #FEFF98;
					}
					& .check {
						color: #01785A;
					}

				}

				@media all and (max-width: 1600px) {
					grid-template-columns: 2fr 9fr 7fr .5fr .5fr .5fr;

					@media all and (max-width: 800px) {
						& {
							display: block;

						& .icon {
							display: inline-block;
							margin-right: 10px;
						}

						& .collection_name {
							display: inline-block;
						}
					}
				}
			}

			.last_update {
				align-items: center;

				&.env{
					color:#969D69;
				}

				&.fin{
					color:#01785A;
				}

				&.rasc{
					color: #99BCE5;
				}

				.content_title {
					display: block;
					font-size: 14px;
					text-align: center;

					@media all and (max-width: 800px) {
						display: inline-block;
						color: unset;
						font-size: unset;
						margin-right: 10px;
					}
				}

				.content {
					display: block;
					margin-top: -5px;
					text-align: center;

					@media all and (max-width: 800px) {
						display: inline-block;
					}
				}
			}

			.actions {
				display: inline-flex;
				justify-content: space-around;
				color:#FFFFFF;
				font-family: Roboto;
				font-stretch: condensed;

				.view, .delete {
					display: flex;
					align-items: center;
					padding: 9px 15px 10px;
					border: none;
					color: #59708F;
					font-size: 20px;
					border-radius: 5px;
					margin-right: 10px;
					font-family: Roboto;
					max-width: 50px;
					min-width: 50px;
					cursor: pointer;
					transition: 0.666s max-width ease;

					.txt {
						display: inline-block;
						transform: scaleX(0);
						transition: 0.444s transform ease;
						transform-origin: left center;
						margin-left: 10px;
						padding-right: 5px;
						font-size: 20px;
						font-size: 16px;
					}
				}
				.view:hover {
					max-width: 200px;
					color: #e2e41a;
					.txt {
						transform: scaleX(1)
					}
				}
				.delete:hover {
					max-width: 200px;
					color: #d9534f;
					.txt {
						transform: scaleX(1)
					}
				}
			}
		}
	}
</style>
